import React from 'react';
import './ListToolbar.css';

export interface ListToolbarProps {
  filterOptions: { label: string; value: string }[];
  filter: string;
  setFilter: (value: string) => void;
  search: string;
  setSearch: (value: string) => void;
  sortOptions: { label: string; value: string }[];
  sort: string;
  setSort: (value: string) => void;
}

const ListToolbar: React.FC<ListToolbarProps> = ({
  filterOptions,
  filter,
  setFilter,
  search,
  setSearch,
  sortOptions,
  sort,
  setSort,
  // removed create button props
}) => {
  return (
    <div className="list-toolbar dashboard-toolbar event-toolbar">
      <div className="filter-toolbar">
        {filterOptions.map(opt => (
          <button
            key={opt.value}
            className={`filter-button${filter === opt.value ? ' active' : ''}`}
            onClick={() => setFilter(opt.value)}
            type="button"
          >
            {opt.label}
          </button>
        ))}
      </div>
      <div className="search-container">
        <span className="search-icon" role="img" aria-label="search">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
        {sortOptions.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {/* Create button removed, should be handled by parent */}
    </div>
  );
};

export default ListToolbar;
